module.exports = __webpack_public_path__ + "img/pic_popup_loginrequired@3x.b317647f.png";